import React from 'react';
import { Link } from 'react-router-dom';
import { X, Mail, BookOpen } from 'lucide-react';
import logo from '../../../../assets/images/layerff-icon.png';

const AboutUs = ({ aboutModalOpen, setAboutModalOpen }) => { 
  return (
    <>  
     {aboutModalOpen && (
        <div 
            className="fixed inset-0 bg-black/70 z-[100] flex items-center justify-center p-4 backdrop-blur-sm"
            onClick={() => setAboutModalOpen(false)}
        >
            <div 
            className="bg-white dark:bg-gray-900 rounded-xl max-w-full w-full sm:max-w-3xl lg:max-w-4xl p-6 shadow-2xl overflow-hidden max-h-[90vh] overflow-y-auto border border-gray-200 dark:border-gray-700"
            onClick={e => e.stopPropagation()}
            >
            <div className="flex justify-between items-center mb-6 pb-4 border-b border-gray-200 dark:border-gray-700">
                <div>
                <h3 className="text-2xl font-bold dark:text-white flex items-center gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                    About 0x10LayerFF
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
                    Securing the digital frontier since 2022
                </p>
                </div>
                <button 
                onClick={() => setAboutModalOpen(false)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800"
                aria-label="Close about modal"
                >
                <X size={24} />
                </button>
            </div>
            
            <div className="prose dark:prose-invert max-w-none">
                <div className="mb-8">
                <div className="flex flex-col md:flex-row gap-6">
                    <div className="md:w-1/3">
                     <div className="bg-gradient-to-br  rounded-lg p-0 aspect-square flex items-center justify-center overflow-hidden">
                    <img 
                        src={logo} 
                        alt="Security Layers" 
                        className="w-full h-full object-cover"  
                    />                        
                    </div>
                    </div>
                    <div className="md:w-2/3">
                    <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">Our Origin Story</h4>
                    <p className="text-gray-700 dark:text-gray-300">
                        0X10LayerFF is a group of cybersecurity enthusiasts dedicated to developing an all-in-one security platform. Founded in 2022, formation was driven by the belief that cybersecurity should be accessible, practical, and effective for everyone. By combining our skills, creativity, and commitment, we developed tools that address real-world security challenges. Each tool reflects our dedication to protecting users from cyber threats while fostering trust and resilience in the digital ecosystem.
                        At 0x10layerff, collaboration is at the heart of everything we do. Our group thrives on continuous learning, innovation, and adapting to the ever-changing cybersecurity landscape. Together, we aim to empower users with cutting-edge solutions that safeguard their digital environments.
                    </p>                    
                    </div>
                </div>
                </div>

                <div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">Our Mission</h4>
                <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-5 border border-blue-100 dark:border-blue-900/30">
                    <p className="text-gray-700 dark:text-gray-300 italic">
                    To enhance digital security by integrating various cybersecurity tools into a single, accessible platform.
                    </p>
                </div>
                </div>

                <div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">The 0x10LayerFF Difference</h4>
                <div className="grid md:grid-cols-2 gap-4">
                    <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div className="flex items-start gap-3">
                        <div className="bg-blue-100 dark:bg-blue-900/30 p-2 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                        </svg>
                        </div>
                        <div>
                        <h5 className="font-medium text-gray-900 dark:text-white mb-1">Integrated Protection</h5>
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                            16 security layers working in concert, eliminating gaps between point solutions
                        </p>
                        </div>
                    </div>
                    </div>
                    <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div className="flex items-start gap-3">
                        <div className="bg-blue-100 dark:bg-blue-900/30 p-2 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                        </svg>
                        </div>
                        <div>
                        <h5 className="font-medium text-gray-900 dark:text-white mb-1">AI-Powered Defense</h5>
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                            Machine learning models trained on 10M+ threat indicators for proactive protection
                        </p>
                        </div>
                    </div>
                    </div>
                    <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div className="flex items-start gap-3">
                        <div className="bg-blue-100 dark:bg-blue-900/30 p-2 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                        </div>
                        <div>
                        <h5 className="font-medium text-gray-900 dark:text-white mb-1">Zero Trust Architecture</h5>
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                            Continuous verification and least-privilege access built into every component
                        </p>
                        </div>
                    </div>
                    </div>
                    <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                    <div className="flex items-start gap-3">
                        <div className="bg-blue-100 dark:bg-blue-900/30 p-2 rounded-full">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-blue-600 dark:text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                        </svg>
                        </div>
                        <div>
                        <h5 className="font-medium text-gray-900 dark:text-white mb-1">Compliance Ready</h5>
                        <p className="text-sm text-gray-700 dark:text-gray-300">
                            Pre-mapped controls for SOC 2, ISO 27001, GDPR with automated evidence collection
                        </p>
                        </div>
                    </div>
                    </div>
                </div>
                </div>

            {/*<div className="mb-8">
                <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-3">Our Leadership</h4>
                <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {[
                    {
                        name: "Alex Morgan",
                        title: "Founder & CEO",
                        bio: "Former CISO at Fortune 100 company, 20+ years in cybersecurity",
                        expertise: "Threat Intelligence, Security Architecture"
                    },
                    {
                        name: "Jamie Chen",
                        title: "CTO",
                        bio: "Ex-Google security engineer, AI/ML specialist",
                        expertise: "Machine Learning, Cryptography"
                    },
                    {
                        name: "Taylor Smith",
                        title: "CSO",
                        bio: "Led security teams at three unicorn startups",
                        expertise: "Cloud Security, Compliance"
                    }
                    ].map((leader, index) => (
                    <div key={index} className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
                        <div className="h-10 w-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-bold mb-3">
                        {leader.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        <h5 className="font-medium text-gray-900 dark:text-white">{leader.name}</h5>
                        <p className="text-sm text-blue-600 dark:text-blue-400 mb-2">{leader.title}</p>
                        <p className="text-xs text-gray-600 dark:text-gray-400 mb-2">{leader.bio}</p>
                        <p className="text-xs text-gray-500 dark:text-gray-500">
                        <span className="font-medium">Expertise:</span> {leader.expertise}
                        </p>
                    </div>
                    ))}
                </div>
                </div>*/}

                <div className="mt-8 pt-6 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row justify-between items-center gap-4">
                <div className="text-sm text-gray-500 dark:text-gray-400">
                    Ready to experience the 0x10LayerFF difference?
                </div>
                <div className="flex gap-3">
                    <Link 
                    to="/"
                    className="px-4 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors text-sm font-medium flex items-center gap-2"
                    >
                    <BookOpen size={16} />
                    Full Company Story
                    </Link>
                    <Link 
                    to="/"
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors text-sm font-medium flex items-center gap-2"
                    >
                    <Mail size={16} />
                    Contact Our Team
                    </Link>
                </div>
                </div>
            </div>
            </div>
        </div>
        )}
    </>
  );
};

export default AboutUs;
